import React, { useEffect, useState } from 'react';

function StickyLogo() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`sticky-logo-container${show ? ' sticky-logo-visible' : ''}`}>
      <img
        src={process.env.PUBLIC_URL + '/logo192.png'}
        alt="Logo"
        className="sticky-logo-img"
      />
    </div>
  );
}

export default StickyLogo; 